/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { closest } from '@/js/utils/css'
import { findAll, findOne } from '@/js/utils/dom'

/** Remembers each code block's server-rendered mask between reveal/hide clicks. */
const maskCache = new WeakMap()

function toggleIcons(element) {
    findAll('.icon-show, .icon-hide', element).forEach((icon) => {
        icon.classList.toggle('d-none')
    })
}

/**
 * Toggle visibility of password fields (`type` flip) or masked code blocks
 * (`data-password` swap).
 *
 * @type {Listener}
 */
export default {
    selector: '.btn-toggle-password',
    connect(element) {
        const onClick = () => {
            const wrapper = closest(element, 'div')
            if (!wrapper) {
                return
            }

            const input = findOne('.password-input', wrapper)
            const code = findOne('.password-code', wrapper)

            if (input) {
                const isPassword = input.getAttribute('type') === 'password'
                input.setAttribute('type', isPassword ? 'text' : 'password')
                toggleIcons(element)
                element.setAttribute('title', isPassword ? 'Hide password' : 'Show password')
            } else if (code) {
                const { password } = code.dataset
                const isHidden = code.textContent !== password
                if (isHidden) {
                    // Stash the server-rendered mask so the template stays the only place defining the pattern
                    maskCache.set(code, code.textContent)
                }
                code.textContent = isHidden ? password : maskCache.get(code)
                toggleIcons(element)
                element.setAttribute('title', isHidden ? 'Hide password' : 'Show password')
            }
        }

        element.addEventListener('click', onClick)

        return () => element.removeEventListener('click', onClick)
    },
}
